module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/40ed288c687ce245b74779771e16a9d1.png";